import {Component} from '@angular/core';

@Component({
  selector: 'app-hand-money-icon',
  templateUrl: './hand-money-icon.component.html'
})
export class HandMoneyIconComponent {
}
